module.exports = __webpack_public_path__ + "static/img/prize_txt.b9ca5cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/subscribe/prize_txt.png
// module id = fHcF
// module chunks = 1